import { compose, withProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTCityDetails from './BOTCityDetails'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'

const withCityDetails = withProps(({ stores }) => ({
  hasStores: Boolean(stores.length)
}))

export default compose(
  withType({ type: 'BOTCityDetails' }),
  withProps(() => ({ navigateToQuickApptPage: true })),
  withCityDetails,
  withRequestApptClick
)(BOTCityDetails)
